module.exports = __webpack_public_path__ + "img/apple-podcast.3b77ea3d.svg";